import React from 'react';

import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Chart from 'chart.js';
import palette from 'theme/palette';
import { DashboardSessionsGraphFields } from 'modules/environments/interfaces';
import { isClientOperator } from 'utils/role';
import { RolesEnum } from 'modules/authenticate/interfaces';
import { defaultGraphConfig, generateLabels } from 'utils/graphs';

interface SessionHistoryGraphProps {
  dashboardSessionsGraph: DashboardSessionsGraphFields;
  role?: RolesEnum;
  isModal?: boolean;
}

const SessionHistoryGraph = ({
  dashboardSessionsGraph,
  role,
  isModal,
}: SessionHistoryGraphProps) => {
  const containerRef = React.useRef<HTMLCanvasElement>(null);
  const labels = generateLabels(dashboardSessionsGraph?.metrics);

  const config = defaultGraphConfig({
    labels,
    datasets: [
      {
        data: dashboardSessionsGraph?.metrics?.map(item => item?.sessions?.max),
        backgroundColor: palette.yellow,
        borderColor: palette.yellow,
        fill: false,
        tension: 0.4,
      },
      {
        data: dashboardSessionsGraph?.metrics?.map(
          item => item?.vacancies?.max
        ),
        borderColor: palette.digitalBlue,
        backgroundColor: palette.digitalBlue,
        fill: false,
        tension: 0.4,
        hidden: isClientOperator(role),
      },
    ],
  });

  if (isModal) {
    config.options.scales.xAxes[0].ticks.display = true;
    config.options.scales.yAxes[0].ticks.display = true;
  }

  React.useEffect(() => {
    let chart;

    if (containerRef.current) {
      chart = new Chart(containerRef.current, config);
    }
    return () => chart?.destroy();
  }, [containerRef, config]);

  return (
    <Grid container>
      <canvas
        ref={containerRef}
        width={isModal ? '850' : 'auto'}
        height={isModal ? '300' : '100'}
      ></canvas>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { data },
  environments: { dashboardSessionsGraph },
}: ApplicationState) => ({
  dashboardSessionsGraph,
  role: data?.role,
});

export default connect(mapStateToProps, {})(SessionHistoryGraph);
